"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enroll = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const oxDLF = typeof window !== 'undefined' && (window.oxDLF = window.oxDLF || []);
const cookieName = 'ox_experiment_tags';
const getExperimentTags = () => Object.fromEntries((js_cookie_1.default.get(cookieName) || '')
    .split(',')
    .map(tag => tag.split('='))
    .filter(entries => entries.length === 2));
const getNewExperimentTags = (experiment, variant) => [
    '',
    ...Object.entries(Object.assign(Object.assign({}, getExperimentTags()), { [experiment.name]: variant.name })).map(entry => entry.join('=')),
    '',
].join(',');
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random#try_it
function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}
function getRandomFromArray(arr) {
    return arr[getRandomInt(arr.length)];
}
const enroll = (experiment) => {
    if (!oxDLF) {
        console.warn('Trying to start experiment in a non-browser environment! this is a bug!');
        return experiment.variants[0];
    }
    const existingAssignments = getExperimentTags();
    const existingAssignment = experiment.name in existingAssignments &&
        experiment.variants.find(variant => variant.name === existingAssignments[experiment.name]);
    if (existingAssignment) {
        return existingAssignment;
    }
    else {
        const chosenVariant = getRandomFromArray(experiment.variants);
        js_cookie_1.default.set(cookieName, getNewExperimentTags(experiment, chosenVariant), { expires: 30 });
        window.oxDLF.push({ reconfigure: Date.now() });
        return chosenVariant;
    }
};
exports.enroll = enroll;
